import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function PlaySquare(props: IconSvgProps) {
  const { innerColor, color, ...baseProps } = props;

  // Determine if the outer color is light or dark to use contrasting inner color
  const isLightColor = color?.toLowerCase().includes('white');
  const defaultInnerColor = isLightColor ? 'black' : 'white';

  return (
    <BaseLibraryIconSvg {...baseProps} color={color} viewBox='0 0 80 48'>
      <rect width='80' height='48' rx='8' fill='currentColor' />
      <path
        d='M50 23.4286C50 23.9367 49.7301 24.4066 49.2913 24.6626L32.1484 34.6626C31.7065 34.9203 31.1606 34.9221 30.7171 34.6673C30.2735 34.4126 30 33.9401 30 33.4286V13.4286C30 12.917 30.2735 12.4446 30.7171 12.1898C31.1606 11.935 31.7065 11.9369 32.1484 12.1946L49.2913 22.1946C49.7301 22.4506 50 22.9204 50 23.4286Z'
        fill={innerColor || defaultInnerColor}
      />
    </BaseLibraryIconSvg>
  );
}
